import { render, staticRenderFns } from "./qvyu-add.vue?vue&type=template&id=57b2aaf7&scoped=true&"
import script from "./qvyu-add.vue?vue&type=script&lang=js&"
export * from "./qvyu-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b2aaf7",
  null
  
)

export default component.exports